import { downloadFile, getAllQueryParams, getObjectName, getValueFromArray, setQueryParams } from 'utils/utils'
import { useLocation, useSearchParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setModal, setOptions, setSelectedValue } from 'reducers/listReducer'
import {
    ARRAY_FILTER,
    ARRAY_OBJECT_FILTER,
    DATE_FILTER,
    INITIAL_FILTER_VALUE,
    SORT_ORDER,
    STATUS_ORDER,
    TAB_ORDER,
    TAB_ORDER_NAME,
    TABLE_ORDER,
} from 'configs/order/configOrder'
import { List } from 'components/order/list'
import { Alert } from 'avo-ui'
import { useFetch } from 'services/useFetch'
import { API_ORDER } from 'services/apiOrder'
import moment from 'moment'
import { AdvanceFilterContainer } from './AdvanceFilterContainer'
import { RightButtonContainer } from './RightButtonContainer'

export const OrderListContainer = () => {
    const location = useLocation()
    const dispatch = useDispatch()
    const [searchParams, setSearchParams] = useSearchParams()
    const [isResetSelectedItem, setIsResetSelectedItem] = useState(false)
    const [queryFilter, setQueryFilter] = useState({})
    const [queryList, setQueryList] = useState({})
    const { query: INITIAL_DATA_FILTER, selectedValue } = useSelector((state) => state.listReducer)
    const { data: orderList, fetching: getOrderListApi, isLoading } = useFetch(API_ORDER.LIST)
    const { fetching: exportOrderListApi, isLoading: isLoadingExport } = useFetch(API_ORDER.EXPORT)
    const { fetching: bulkUpdateOrderApi, isLoading: isLoadingBulkUpdateOrder } = useFetch(API_ORDER.BULK_CHANGE_STATUS)
    const query = searchParams.size > 0 ? getAllQueryParams(searchParams) : INITIAL_DATA_FILTER

    const getTabName = (status = []) => {
        let newTab
        const findPendingPayment = status?.find((item) => item === 'pending-payment')
        const findOnHold = status?.find((item) => item === 'on-hold')
        const isSingleUnpaid = findPendingPayment || findOnHold
        const isDoubleUnpaid = findPendingPayment && findPendingPayment
        if ((status?.length === 1 && isSingleUnpaid) || (status?.length === 2 && isDoubleUnpaid)) {
            newTab = 'belum dibayar'
        } else if (status?.length !== 1) {
            newTab = 'semua'
        } else {
            newTab = TAB_ORDER_NAME[status[0]]
        }
        return newTab
    }

    useEffect(() => {
        const currentQuery = { ...query }
        const newQueryFilter = { ...INITIAL_FILTER_VALUE }
        Object.entries(currentQuery).forEach(([key, item]) => {
            if (ARRAY_OBJECT_FILTER?.includes(key)) {
                const splitObject = item?.split('|')
                const parseObject = splitObject?.map((i) => JSON.parse(i))
                newQueryFilter[key] = parseObject
                currentQuery[key] = parseObject?.map((i) => i?.value)
            } else if (ARRAY_FILTER?.includes(key)) {
                const valueOfQuery = item?.split(',')
                newQueryFilter[key] = valueOfQuery
                currentQuery[key] = valueOfQuery
            } else if (DATE_FILTER?.includes(key)) {
                newQueryFilter[key] = item
                currentQuery[key] = item
            }
        })
        setQueryFilter({ ...queryFilter, ...newQueryFilter })
        setQueryList(currentQuery)
        dispatch(setSelectedValue({ select: {}, tab: getTabName(currentQuery?.status) }))
        fetchOrderList(currentQuery)
    }, [location?.search])

    useEffect(() => {
        dispatch(
            setOptions({
                sort: SORT_ORDER,
                tab: TAB_ORDER,
                select: STATUS_ORDER,
                table: TABLE_ORDER,
            }),
        )
    }, [])

    const fetchOrderList = (item = { ...queryList }) => {
        getOrderListApi(item)
    }

    const onChangeQuery = (queryParams) => {
        const isReset = getObjectName(queryParams)?.some((item) => ['search', 'start_date', 'status'].includes(item))
        if (isReset) setIsResetSelectedItem(!isResetSelectedItem)
        const params = setQueryParams({ ...query, ...queryParams })
        setSearchParams(params, { replace: true })
    }

    const translateTabNameToStatus = (text) => {
        switch (text) {
            case 'belum dibayar':
                return ['pending-payment', 'on-hold']
            case 'sudah dibayar':
                return ['processing']
            case 'dikemas':
                return ['packing']
            case 'dikirim':
                return ['on-delivery']
            case 'selesai':
                return ['completed']
            case 'dibatalkan':
                return ['cancelled']
            default:
                return []
        }
    }

    const onExport = () => {
        const payload = { order_ids: getValueFromArray(selectedValue?.selectedIds, 'id'), ...queryList }
        exportOrderListApi(payload, '', {}, 'blob').then((response) => {
            downloadFile(null, response, `Order-Export-${moment().format('DD-MM-YYYY')}.xlsx`)
            dispatch(setModal({ export: false }))
        })
    }

    const onChangeTab = (tab) => {
        const newStatus = translateTabNameToStatus(tab)
        const filterQuery = { ...INITIAL_FILTER_VALUE, status: newStatus?.join(',') }
        onChangeQuery({ ...INITIAL_DATA_FILTER, ...filterQuery })
    }

    const rightButtonConfirm = () => {
        bulkUpdateOrderApi({
            status: selectedValue?.select?.value,
            order_ids: getValueFromArray(selectedValue?.selectedIds, 'id'),
        }).then(() => {
            selectedValue?.tab !== 'semua' && setIsResetSelectedItem(!isResetSelectedItem)
            dispatch(setModal({ confirm: false }))
            fetchOrderList()
            return Alert({
                icon: 'success',
                title: 'Success',
                message: 'Status Order Changed !',
            })
        })
    }

    const props = {
        dataList: orderList?.data,
        query,
        onChangeQuery,
        onChangeTab,
        isLoading,
        isLoadingConfirm: isLoadingBulkUpdateOrder,
        isLoadingExport,
        onExport,
        rightButton: () => <RightButtonContainer />,
        rightButtonConfirm,
        filter: () => <AdvanceFilterContainer queryFilter={queryFilter} onChangeQuery={onChangeQuery} />,
        isResetSelectedItem,
    }

    return <List {...props} />
}
